import { ToastContainer } from '@postscript/components';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './components/Layout/SubPageLayout';
import PasswordGate from './components/PasswordGate';
import { usePasswordAuth } from './hooks/usePasswordAuth';
import Home from './pages/Home';
import Sandbox from './pages/Sandbox';
import registry from './pages/sandbox/pages-registry.json';

// Set to true to test password gate in local development
const ENABLE_PASSWORD_IN_DEV = false;

// Loading fallback component
const PageLoader = () => (
  <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>
);

const App = () => {
  const { isAuthenticated, authenticate } = usePasswordAuth();

  // Only require password in production and if password is configured
  // Or if ENABLE_PASSWORD_IN_DEV is true (for local testing)
  const requiresAuth =
    (process.env.NODE_ENV === 'production' || ENABLE_PASSWORD_IN_DEV) &&
    process.env.REACT_APP_SANDBOX_PASSWORD;

  // Show password gate if authentication is required and user is not authenticated
  if (requiresAuth && !isAuthenticated) {
    return <PasswordGate onAuthenticate={authenticate} />;
  }

  // Dynamically load pages from registry
  const dynamicRoutes = registry.pages.map((page) => {
    const PageComponent = lazy(
      () => import(`./pages/sandbox/${page.fileName.replace('.tsx', '')}`),
    );

    return (
      <Route key={page.route} path={page.route}>
        <Suspense fallback={<PageLoader />}>
          <PageComponent />
        </Suspense>
      </Route>
    );
  });

  return (
    <Router>
      <ToastContainer />
      <Switch>
        <Route exact path="/" component={Home} />
        <Layout>
          <Switch>
            {dynamicRoutes}
            <Route exact path="/sandbox" component={Sandbox} />
          </Switch>
        </Layout>
      </Switch>
    </Router>
  );
};

export default App;
